<template>
    <div class="top">
        <div class="topContent">
            <div class="menu_img">
                <img
                    src="@/assets/jhindexLogo.png"
                />
            </div>
            <div class="topMenu">
                <ul class="menu_list">
                    <li class="menu_item" id="home">
                        <router-link to="/">
                            <span class="txt">首页</span></router-link
                        >
                    </li>
                    <li class="menu_item" v-for="(item,index) in dataList" :key="index" @mouseover="overShow" @mouseout="outHide">
                        <span class="txt">{{item.name}}</span>
                        <ul class="sub_list">
                            <li v-for="(sub,sIndex) in item.childs" :key="sIndex" @click="onClick(item,sub)">{{sub.name}}</li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <div class="bg_hover"></div>
    </div>
</template>

<script>
import $ from "jquery";
import { getAction } from "@/api/services";
export default {
    name: "Top",
    inject: ["reload"],
    data() {
        return {
            dataList:[]
        };
    },
    mounted() {
        let that = this;
        $(window).on("scroll", that.handleScroll);
        this.getMenuData();
        // if(sessionStorage.getItem("menuInfo")){
        //     this.dataList =  JSON.parse(sessionStorage.getItem("menuInfo"));
        // }
    },
    watch: {
        $route(to, from) {
            $(window).on("scroll", this.handleScroll);
        },
    },
    created() {

    },
    destroyed() {
        $(window).off("scroll");
    },
    methods: {
        getMenuData(){
            let that = this;
            getAction("/jhwlweb/gwweb/cmsArticleCategory/queryAllCategory")
            .then((res) => {
                if (res.code == 200 && res.success) {
                    this.dataList = res.result;
                }
            });
        },
        handleScroll() {
            if ($(window).scrollTop() > 0) {
                this.isOld = false;
                $(".top").addClass("otherTop");
            } else if (this.$route.path == "/") {
                this.isOld = true;
                $(".top").removeClass("otherTop");
            }
        },
        onClick(item,sub){
            sessionStorage.setItem("activeMenu",JSON.stringify(item)); 

            var path = sub.href?sub.href:"/contentPage";
            var code = sub.menuCategory;
            //  this.$router.push({
            //     path: path,
            //     query:{
            //         code:code
            //     }
            // });
            window.location.href=path+"?code="+code;
        },
        overShow(e) {
            let that = this;
            that.$nextTick(() => {
                $(".bg_hover").removeClass("hideBg").addClass("showBg");
            });
        },
        outHide() {
            this.$nextTick(() => {
                $(".bg_hover").removeClass("showBg").addClass("hideBg");
            });
        },
    },
};
</script>

<style scoped lang="less">
.menu_list {
    display: block;
    height: 90px;
    position: absolute;
    right: 0;
    top: 0px;
    cursor: pointer;
    opacity: 1;
    transition: opacity 0.3s linear;
    transform: translate(0px, 0);
}
.menu_list .menu_item {
    display: inline-block;
    height: 90px;
    float: left;
    padding: 0 18px;
    position: relative;
    &:hover{
        .sub_list{
            display: block;
        }
        .txt{
            color: #2C9F6E;
        }
            li:hover{
                color: #2C9F6E;
            }
    }
}
.menu_list .menu_item .txt {
    display: block;
    height: 90px;
    line-height: 90px;
    font-size: 20px;
    color: #999999;
    font-weight: bold;
    opacity: 0.95;
    -webkit-transition: color 0.3s linear;
    position: relative;
    z-index: 2;
}

.menu_list .menu_item .txt:after {
    display: block;
    content: "";
    height: 4px;
    width: 100%;
    position: absolute;
    bottom: 19px;
    left: 0px;
    background: #2C9F6E;
    opacity: 0;
    -webkit-transition: transform 0.2s ease-out, opacity 0.2s ease-out;
    transform-origin: 50% 0%;
    transform: scale(0.01, 1);
}
.menu_list .menu_item .txt:before {
    display: none;
    content: "";
    height: 340px;
    width: 100%;
    position: absolute;
    top: 19px;
    left: -10px;
    background: #2C9F6E;
    opacity: 1;
}
// .menu_list .menu_item:hover .txt{
//     color: #2C9F6E;
// }
.menu_list .menu_item:hover .txt:after {
    transform: scale(1, 1);
    opacity: 1;
}
.menu_list .menu_item.menu_item_lan {
    display: none;
}
.menu_list .menu_item .menu_hook {
    width: 100%;
    height: 380px;
    position: absolute;
    left: -36px;
    top: 0px;
    z-index: 3;
}
.sub_list {
    display: none;
    position: absolute;
    width: 160px;
    left: 50%;
    margin-left: -98px;
    text-align: center;
    z-index: 2;
    color: #bebebe;
    li {
        margin-bottom: 20px;
    }
    .activeLi {
        color: #2C9F6E;
    }
}
@keyframes a_bg_hover_show {
    0% {
        -webkit-transform: scale(1, 0.5);
        opacity: 0;
    }
    100% {
        -webkit-transform: scale(1, 1);
        opacity: 1;
    }
}
@keyframes a_bg_hover_hide {
    0% {
        -webkit-transform: scale(1, 1);
        opacity: 1;
    }
    100% {
        -webkit-transform: scale(1, 0.5);
        opacity: 0;
    }
}
.showBg {
    background: rgba(255, 255, 255, 1);
    -webkit-animation: a_bg_hover_show 0s ease-out both;
    -webkit-transform-origin: 50% 0%;
}
.hideBg {
    background:none;
    -webkit-animation: a_bg_hover_hide 0s ease-out both;
    -webkit-transform-origin: 50% 0%;
}
// .showColorStyle {
//     color: #999999 !important;
// }
.otherTop {
    background: #ffffff;
    box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.1);
}
.top {
    z-index: 11;
    font-size: 16px;
    position: fixed;
    top: 0;
    width: 100%;
    margin: 0 auto;
    background: #ffffff;
    .topContent {
        z-index: 2;
        position: relative;
        margin: 0px auto;
        max-width: 1300px;
        display: flex;
        .menu_img {
            height: 90px;
            line-height: 90px;
            img{
                display: block;
            }
        }
    }
    .bg_hover {
        z-index: 1;
        width: 100%;
        height: 350px;
        pointer-events: none;
        position: absolute;
        top: 0px;
        left: 0px;
    }
}
</style>
